import { ComponentState } from "../types";
import { defaultPagination } from "app/redux/initialState";
import { sortOrder } from "app/types";

export const initialState: ComponentState = {
  loading: false,
  buttonLoading: false,
  isComponentModalOpen: false,
  isArchiveModalOpen: false,

  form: {
    _id: "",
    name: "",
    lead: "",
    defaultAssignee: "",
    description: "",
    isArchived: false,
    ticketCounts: [],
    teamId: "",
    projectId: "",
    createdBy: "",
    createdAt: "",
    updatedAt: "",
  },
  archiveComponentData: null,

  list: [],

  pagination: {
    ...defaultPagination,
    perPage: 10,
    orderBy: "createdAt",
    orderDirection: sortOrder.DESC,
  },
  fieldLoading: false
};
